class MaterialIcon extends HTMLElement {
    connectedCallback() {
        const name = this.getAttribute("icon"); // z.B. "call", "mail"
        this.innerHTML = `
            <svg class="wx-icon" aria-hidden="true">
                <use href="#wx-icons-${name}"></use>
            </svg>
        `;
    }
}

customElements.define("custom-icon", MaterialIcon);


window.onload = pageLoaded;
window.onscroll = scrollFunction;
window.addEventListener('hashchange', checkHash);

function pageLoaded() {
    navFixed();
    initMobileNav();
    initNavDropdowns();
    splideSliders();
    feedbackLoop();
    checkHash();
    initGmap();
}

function scrollFunction() {
    navFixed();
}

function navFixed() {

    const topbarEl = document.querySelector('.top-bar');
    const navbar = document.querySelector('.nav-bar');

    if (!topbarEl || !navbar) return;


    if (window.innerHeight <= 992) {
        if (window.pageYOffset >= 1) {
            navbar.classList.add('fixed');
        } else {
            navbar.classList.remove('fixed');
        }
        return;
    }

    const topbar = topbarEl.clientHeight;

    if (window.pageYOffset >= topbar) {
        navbar.classList.add('fixed');
    } else {
        navbar.classList.remove('fixed');
    }
}


function checkHash() {
    if (!window.location.hash) return;

    const hash = window.location.hash.substring(1); // ohne #
    const target = document.querySelector('.' + CSS.escape(hash));
    if (!target) return;

    const nav = document.querySelector('.nav-bar');
    const navHeight = nav ? nav.offsetHeight : 0;

    const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        navHeight;

    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
    });
}






function toggleAccordion(headEl) {
    const itemEl = headEl.closest(".accordion-item");
    if (!itemEl) return;

    const listEl = itemEl.closest(".accordion-list");
    if (!listEl) return;

    const contentEl = itemEl.querySelector(".accordion-content");
    if (!contentEl) return;

    const isOpen = itemEl.classList.contains("active");

    // Immer nur eins offen: alle anderen schließen (smooth)
    listEl.querySelectorAll(".accordion-item.active").forEach((openItem) => {
        if (openItem === itemEl) return;
        openItem.classList.remove("active");
        const openContent = openItem.querySelector(".accordion-content");
        if (openContent) collapseSmooth(openContent);
    });

    // aktuelles togglen
    if (isOpen) {
        itemEl.classList.remove("active");
        collapseSmooth(contentEl);
    } else {
        itemEl.classList.add("active");
        expandSmooth(contentEl);
    }
}

function expandSmooth(el) {
    // Falls gerade am Collapsen: Transition resetten
    el.style.transition = "none";

    // Startzustand
    el.style.overflow = "hidden";
    el.style.height = "0px";

    // Reflow + im nächsten Frame animieren
    el.offsetHeight;
    requestAnimationFrame(() => {
        el.style.transition = "height 300ms ease";
        el.style.height = el.scrollHeight + "px";
    });

    const onEnd = (e) => {
        if (e.propertyName !== "height") return;
        el.removeEventListener("transitionend", onEnd);
    };
    el.addEventListener("transitionend", onEnd);
}

function collapseSmooth(el) {
    // Wenn height = auto ist: aktuelle Pixelhöhe fixieren
    el.style.transition = "none";
    el.style.overflow = "hidden";

    // Wichtig: echte aktuelle Höhe nehmen (nicht scrollHeight)
    const current = el.getBoundingClientRect().height;
    el.style.height = current + "px";

    // Reflow + im nächsten Frame animieren
    el.offsetHeight;
    requestAnimationFrame(() => {
        el.style.transition = "height 300ms ease";
        el.style.height = "0px";
    });

    const onEnd = (e) => {
        if (e.propertyName !== "height") return;
        el.removeEventListener("transitionend", onEnd);
    };
    el.addEventListener("transitionend", onEnd);
}

function splideSliders() {
    initHeaderSlider();
    initGallerySlider();
    initUSPSlider();
    initServiceSlider();
    initStepSlider();
}

function initHeaderSlider() {
    if (document.querySelector('.splide[data-slider="header"]')) {
        document.querySelectorAll('.splide[data-slider="header"]').forEach(function (el) {
            new Splide(el, {
                type: 'loop',
                autoplay: true,
                interval: 5000,
                speed: 1200,
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                drag: true,
                rewind: true,
            }).mount();
        });
    }
}

function initGallerySlider() {
    if (document.querySelector('.splide[data-slider="gallery"]')) {
        document.querySelectorAll('.splide[data-slider="gallery"]').forEach(function (el) {
            new Splide(el, {
                type: 'loop',
                perPage: 4.5,
                perMove: 1,
                autoplay: true,
                focus: 'center',
                interval: 5000,
                speed: 1200,
                arrows: true,
                pagination: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                lazyLoad: true,
                preloadPages: 1,
                keyboard: true,
                drag: true,
                gap: '1rem',
                breakpoints: {
                    1200: {
                        perPage: 3.5,
                        gap: '1rem',
                    },
                    992: {
                        perPage: 2.5,
                        gap: '1rem',
                    },
                    640: {
                        perPage: 1.5,
                        gap: '1rem',
                    }
                }
            }).mount();
        });
    }
}

function initUSPSlider() {
    const selector = '.splide[data-slider="usp-list"]';
    const mq = window.matchMedia('(max-width: 992px)'); // Breakpoint anpassen
    const instances = new Map();

    function mount(el) {
        if (instances.has(el)) return;

        const splide = new Splide(el, {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            arrows: false,
            pagination: true,
            drag: true,
            speed: 600,
            autoplay: true,
            focus: 'center',
            interval: 5000,
            keyboard: true,
            drag: true,
            gap: '1rem',
        });

        splide.mount();
        instances.set(el, splide);
    }

    function destroy(el) {
        const splide = instances.get(el);
        if (!splide) return;

        splide.destroy(true);
        instances.delete(el);
    }

    function update() {
        if (!document.querySelector(selector)) return;

        document.querySelectorAll(selector).forEach(function (el) {
            if (mq.matches) {
                mount(el);
            } else {
                destroy(el);
            }
        });
    }

    // initial
    update();

    // bei Breakpoint-Wechsel
    if (mq.addEventListener) {
        mq.addEventListener('change', update);
    } else {
        mq.addListener(update); // Safari fallback
    }
}

function initServiceSlider() {
    if (document.querySelector('.splide[data-slider="service-list"]')) {
        document.querySelectorAll('.splide[data-slider="service-list"]').forEach(function (el) {

            var mq = window.matchMedia('(max-width: 992px)');
            var splideInstance = null;

            function buildSplideDom() {
                if (el.classList.contains('is-splide')) return;

                // Slides aus vorhandenem Markup ziehen
                var items = Array.prototype.slice.call(el.querySelectorAll(':scope > .service-item'));
                if (!items.length) return;

                // Track + List bauen
                var track = document.createElement('div');
                track.className = 'splide__track';

                var list = document.createElement('div');
                list.className = 'splide__list';

                // Items in Slides wrappen
                items.forEach(function (item) {
                    var slide = document.createElement('div');
                    slide.className = 'splide__slide';
                    slide.appendChild(item);
                    list.appendChild(slide);
                });

                track.appendChild(list);

                // Root leeren und Track einfügen
                el.innerHTML = '';
                el.appendChild(track);

                el.classList.add('is-splide');
            }

            function destroySplideDom() {
                if (!el.classList.contains('is-splide')) return;

                // service-items wieder aus Slides herausziehen
                var items = [];
                el.querySelectorAll('.splide__slide > .service-item').forEach(function (item) {
                    items.push(item);
                });

                // Root zurückbauen (nur service-items direkt rein)
                el.innerHTML = '';
                items.forEach(function (item) {
                    el.appendChild(item);
                });

                el.classList.remove('is-splide');
            }

            function mount() {
                if (splideInstance) return;

                buildSplideDom();

                // Falls aus irgendeinem Grund keine Track/List existiert: abbrechen
                if (!el.querySelector('.splide__track')) return;

                splideInstance = new Splide(el, {
                    type: 'loop',
                    perPage: 2.5,
                    perMove: 1,
                    arrows: false,
                    pagination: false,
                    drag: true,
                    speed: 600,
                    autoplay: true,
                    focus: 'center',
                    interval: 5000,
                    keyboard: true,
                    drag: true,
                    gap: '2rem',
                    breakpoints: {
                        767: {
                            perPage: 1.5,
                            gap: '1rem',
                        }
                    }
                });

                splideInstance.mount();
            }

            function unmount() {
                if (!splideInstance) return;

                splideInstance.destroy(true);
                splideInstance = null;

                destroySplideDom();
            }

            function toggle() {
                if (mq.matches) {
                    mount();
                } else {
                    unmount();
                }
            }

            // initial
            toggle();

            // on change
            if (mq.addEventListener) {
                mq.addEventListener('change', toggle);
            } else {
                // Safari fallback
                mq.addListener(toggle);
            }
        });
    }
}

function initStepSlider() {
    var selector = '.splide[data-slider="steps"]';
    var breakpoint = window.matchMedia('(max-width: 991px)');

    function mount(el) {
        if (el._splideSteps) return;

        el._splideSteps = new Splide(el, {
            type: 'slide',
            perPage: 1.35,
            perMove: 1,
            arrows: false,
            pagination: false,
            drag: true,
            gap: '1rem',
            speed: 800,
            rewind: false,
            autoplay: false,
            focus: 'center',
            trimSpace: false,      // wichtig!
        });

        el._splideSteps.mount();
    }

    function destroy(el) {
        if (!el._splideSteps) return;

        // true => Splide räumt Klassen/Inline-Styles auf, damit Desktop-Grid wieder sauber greift
        el._splideSteps.destroy(true);
        el._splideSteps = null;
    }

    function toggle() {
        document.querySelectorAll(selector).forEach(function (el) {
            if (breakpoint.matches) {
                mount(el);
            } else {
                destroy(el);
            }
        });
    }

    // Initial
    toggle();

    // Reagiert auf Breakpoint-Wechsel
    if (typeof breakpoint.addEventListener === 'function') {
        breakpoint.addEventListener('change', toggle);
    } else {
        // Safari fallback
        breakpoint.addListener(toggle);
    }
}





function feedbackLoop() {
    if (typeof gsap === 'undefined') {
        return;
    }
    const track = document.querySelector(".feedback-slider .feedback-track");
    const slider = document.querySelector(".feedback-slider");
    if (!track || !slider) return;

    if (!track.dataset.cloned) {
        const cards = Array.from(track.children);
        cards.forEach((card) => {
            const clone = card.cloneNode(true);
            clone.classList.add("feedback-card--clone");
            track.appendChild(clone);
        });
        track.dataset.cloned = "true";
    }

    const totalWidth = track.scrollWidth / 2; // eine Sequenz

    gsap.to(track, {
        x: -totalWidth,
        duration: 60,
        repeat: -1,
        ease: "linear",
        modifiers: {
            x: (x) => {
                const current = parseFloat(x);
                // sorgt für endlosen Loop
                if (current <= -totalWidth) {
                    return "0px";
                }
                return x;
            },
        },
    });

    // Hover pausieren (optional)
    slider.addEventListener("mouseenter", () => gsap.globalTimeline.pause());
    slider.addEventListener("mouseleave", () => gsap.globalTimeline.resume());
}


function initMobileNav() {
    const navBars = document.querySelectorAll('.nav-bar');

    if (!navBars.length) return;

    navBars.forEach(function (navBar) {
        const nav = navBar.closest('.nav') || navBar; // falls .nav außenrum existiert
        const toggle = navBar.querySelector('[data-nav-toggle]');
        const menu = navBar.querySelector('[data-nav-menu]');

        if (!toggle || !menu) return;

        // Initial state
        toggle.setAttribute('aria-expanded', 'false');

        function openNav() {
            nav.classList.add('open');
            toggle.setAttribute('aria-expanded', 'true');
        }

        function closeNav() {
            nav.classList.remove('open');
            toggle.setAttribute('aria-expanded', 'false');
        }

        function toggleNav() {
            if (nav.classList.contains('open')) {
                closeNav();
            } else {
                openNav();
            }
        }

        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            toggleNav();
        });

        // Klick außerhalb schließt
        document.addEventListener('click', function (e) {
            if (!nav.classList.contains('open')) return;
            if (navBar.contains(e.target)) return;
            closeNav();
        });

        // ESC schließt
        document.addEventListener('keydown', function (e) {
            if (!nav.classList.contains('open')) return;
            if (e.key === 'Escape') closeNav();
        });

        // Bei Klick auf einen Link im Menü schließen (Mobile UX)
        menu.querySelectorAll('a').forEach(function (a) {
            a.addEventListener('click', function () {
                if (nav.classList.contains('open')) closeNav();
            });
        });

        // Resize cleanup (Breakpoint bitte an dein CSS anpassen!)
        // Wenn du z.B. ab 1024px Desktop-Navi hast:
        const desktopMq = window.matchMedia('(min-width: 1024px)');

        function handleBreakpoint(e) {
            if (e.matches) {
                // Desktop: Zustand zurücksetzen
                closeNav();
            }
        }

        // initial + listener
        handleBreakpoint(desktopMq);

        if (desktopMq.addEventListener) {
            desktopMq.addEventListener('change', handleBreakpoint);
        } else {
            // Safari fallback
            desktopMq.addListener(handleBreakpoint);
        }
    });
}


function initNavDropdowns() {
    const navMenus = document.querySelectorAll('[data-nav-menu]');

    if (!navMenus.length) return;

    navMenus.forEach(function (menu) {
        const dropdownItems = menu.querySelectorAll('.has-dropdown');

        dropdownItems.forEach(function (item) {
            const toggle = item.querySelector('.dropdown-icon');
            const dropdown = item.querySelector('.nav-dropdown');

            if (!toggle || !dropdown) return;

            // initial state
            item.classList.remove('is-open');

            toggle.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const isOpen = item.classList.contains('is-open');

                // alle anderen schließen (Accordion-Verhalten)
                dropdownItems.forEach(function (other) {
                    other.classList.remove('is-open');
                });

                // aktuellen togglen
                if (!isOpen) {
                    item.classList.add('is-open');
                }
            });
        });
    });
}


function initGmap() {
    // --- Config ---
    const COOKIE_NAME = "gmaps_consent";
    const COOKIE_DAYS = 180;

    // Dein Embed-Iframe (kannst du 1:1 so lassen)
    const IFRAME_HTML = `
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d20685.060637485672!2d9.4175074!3d49.604677849999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4798081277b8312f%3A0x2dbbdc9bb32e7d49!2sSchillerstra%C3%9Fe%206%2C%2074736%20Hardheim!5e0!3m2!1sde!2sde!4v1766508773402!5m2!1sde!2sde"
      width="600"
      height="450"
      style="border:0;"
      allowfullscreen
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  `.trim();

    // --- Cookie helpers ---
    const setCookie = (name, value, days) => {
        const d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        // SameSite=Lax: ok für Consent-Cookie, path=/ damit siteweit gilt
        document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; ${expires}; path=/; SameSite=Lax`;
    };

    const getCookie = (name) => {
        const n = encodeURIComponent(name) + "=";
        const parts = document.cookie.split(";").map(p => p.trim());
        for (const p of parts) {
            if (p.startsWith(n)) return decodeURIComponent(p.substring(n.length));
        }
        return null;
    };

    // --- DOM helpers ---
    const mountMap = (root) => {
        const uid = root.getAttribute("data-map-uid");
        const container = root.querySelector(`#gmap-${uid}.gmap-container`) || root.querySelector(".gmap-container");
        const consentBox = root.querySelector(".gm-consent");

        if (!container) return;

        // nicht doppelt einfügen
        if (!container.dataset.gmapLoaded) {
            container.innerHTML = IFRAME_HTML;
            container.dataset.gmapLoaded = "1";
        }

        if (consentBox) consentBox.style.display = "none";
    };

    const showConsent = (root) => {
        const consentBox = root.querySelector(".gm-consent");
        if (consentBox) consentBox.style.display = "";
    };

    // --- Init ---
    const roots = document.querySelectorAll(".google-maps[data-map-uid]");
    if (!roots.length) return;

    const hasConsent = getCookie(COOKIE_NAME) === "1";

    roots.forEach((root) => {
        const btn = root.querySelector(".gm-consent-btn");

        if (hasConsent) {
            mountMap(root);
            return;
        }

        showConsent(root);

        if (btn) {
            btn.addEventListener("click", () => {
                setCookie(COOKIE_NAME, "1", COOKIE_DAYS);
                mountMap(root);
            }, { passive: true });
        }
    });
}
